import Carousel from "./CommonCarouselComponent";
import { isSuperbrandHeroPresent } from "@/redux/actions/headerAction";
import { useSelector, useDispatch } from "react-redux";

const FeatureCarousel = (props) => {
  const isSuperbrandHeroPresent = useSelector(
    (state) => state.header.isSuperbrandHeroPresent
  );
  const productsList = props.isInnerCarousel ? props._cardList : props.cardList;
  return (
    <>
      <Carousel
        desktopSlidesToShow={3}
        desktopSlidesToScroll={3}
        tabletSlidesToShow={2}
        tabletSlidesToScroll={2}
        mobileSlidesToShow={1}
        mobileSlidesToScroll={1}
        carouselClass={`feature-carousel-wrapper ${isSuperbrandHeroPresent?"sb_height":""}`}
        productsList={productsList}
        isFeature={true}
        isInnerCarousel={props.isInnerCarousel}
        id={isSuperbrandHeroPresent && !props.isInnerCarousel ?  "feature-carousel-id" : ""}
        isProductCarousel={false}
        {...props}
      />
    </>
  );
};
export default FeatureCarousel;
